import { axiosJSONInstance } from '@/config';
import { SmartPasteResponse } from '@/types/smartPaste';

/** Max characters core accepts in one paste. */
export const SMART_PASTE_MAX_CHARS = 5000;

// Parse free-form order text into a create-order preview. Never creates an order.
export const parseSmartPaste = async (text: string): Promise<SmartPasteResponse> => {
  const response = await axiosJSONInstance.post(`/merchants/orders/smart-paste`, { text });
  return response.data;
};
